import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AdminAuthService } from '../services/admin-auth.service';

/** On admin API 401/403, revoke admin access and redirect to the access-denied page. */
@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly adminAuth: AdminAuthService,
    private readonly router: Router
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = req.url;
    if (!url.includes('/api/admin/') || url.includes('/api/admin/auth/status')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
          const message =
            (err.error as { error?: string } | null)?.error ??
            'Admin sign-in is required to access this area.';
          this.adminAuth.denyAccess(message);
          if (!this.router.url.startsWith('/access-denied')) {
            void this.router.navigate(['/access-denied'], { replaceUrl: true });
          }
        }
        return throwError(() => err);
      })
    );
  }
}
